import React from "react"
import { ThemeProvider } from "@mui/material/styles"
import theme from "./src/theme"
import "./src/styles/fonts.css"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
)
